import { Box, Grid } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Form } from './form';
import { StyledAppBar } from './header';
import { Info } from './info';

export const AppComponent = () => {
  const { i18n } = useTranslation();
  const { language } = useParams();

  React.useEffect(() => {
    i18n.changeLanguage(language === 'en' || language === 'cs' ? language : undefined);
    document.documentElement.lang = language ?? i18n.language;
  }, [language, i18n]);

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <StyledAppBar />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Grid
          sx={{
            display: { xs: 'none', md: 'block', lg: 'block' }
          }}
          item
          sm={12}
          md={6}
          lg={5}
        >
          <Info />
        </Grid>
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundImage: { xs: 'none', sm: 'url(images/bg.png)', md: 'none', lg: 'none' },
            backgroundSize: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '0% 100%',
            minHeight: '98vh'
          }}
          item
          sm={12}
          md={6}
          lg={7}
        >
          <Form />
        </Grid>
      </Grid>
    </Box>
  );
};
